export enum CompanyProfileActionType {
  Print = 'print',
}
